import { render, staticRenderFns } from "./ChannelsPage.vue?vue&type=template&id=fb926dae"
import script from "./ChannelsPage.vue?vue&type=script&lang=js"
export * from "./ChannelsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports